import { selectApiData, selectApiNoContent } from 'util/selector/apiSelector';

import { ApiMessage } from 'api/const';
import { AxiosInstance, AxiosResponse } from 'axios';

import { DepartmentDto, DepartmentModel, mapDepartmentDtoToModel } from './dto/Department.dto';

export class DepartmentApi {
  constructor(private client: AxiosInstance) {}

  list(projectId: number): Promise<DepartmentModel[]> {
    return this.client
      .get(`/api/v1/project/${projectId}/department`)
      .then(selectApiData)
      .then((entries: DepartmentDto[]) => entries.map((entry) => mapDepartmentDtoToModel(entry)));
  }

  upload(projectId: number, file: File): Promise<AxiosResponse<void>> {
    const data = new FormData();
    data.append('file', file);

    return this.client.post(`/api/v1/project/${projectId}/departments-submit`, data);
  }

  preview(projectId: number, file: File): Promise<DepartmentModel[]> {
    const data = new FormData();
    data.append('file', file);

    return this.client
      .post(`/api/v1/project/${projectId}/departments-preview`, data)
      .then(selectApiData)
      .then((entries: DepartmentDto[]) => entries.map((entry) => mapDepartmentDtoToModel(entry)));
  }

  downloadChangeReport(projectId: number, file: File): Promise<AxiosResponse<Blob>> {
    const data = new FormData();
    data.append('file', file);

    return this.client.post<Blob>(`/api/v1/project/${projectId}/departments-preview`, data, {
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
      responseType: 'blob',
    });
  }

  add(projectId: number, name: string): Promise<DepartmentModel> {
    return this.client
      .post(`/api/v1/project/${projectId}/department`, { name: name })
      .then(selectApiData)
      .then((entry) => mapDepartmentDtoToModel(entry));
  }

  edit(departmentId: number, name: string): Promise<DepartmentModel> {
    return this.client
      .post(`/api/v1/department/${departmentId}`, { name: name })
      .then(selectApiData)
      .then((entry) => mapDepartmentDtoToModel(entry));
  }

  delete(departmentId: number): Promise<void> {
    return this.client
      .delete<ApiMessage.Deleted>(`/api/v1/department/${departmentId}`)
      .then(selectApiNoContent);
  }

  reorder(order: number[]): Promise<any> {
    return this.client.post(`/api/v1/department/reorder`, { order });
  }

  changeParent(childId: number, parentId: number): Promise<any> {
    return this.client.post(`/api/v1/department/${childId}/change-parent`, { parent: parentId });
  }
}
